module.exports = __webpack_public_path__ + "static/img/zhengxiaoyue.1b7a7a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/zhengxiaoyue.jpg
// module id = jinL
// module chunks = 0